import React from "react";
import "./name-list.styles.scss";
import Participant from "../participant/participant.component";

const NameList = ({ title, list }) => {
  return (
    <div className="name-list">
      <h2>{title}</h2>
      {list.map((participant) => (
        <Participant key={participant[0]} name={participant[1]} />
      ))}
    </div>
  );
};

export default NameList;
